import { Injectable } from "@angular/core";
import { Capacitor, registerPlugin } from "@capacitor/core";
import * as _ from "lodash";

interface FacebookSdkAnalyticsPlugin {
  trackPurchase(options: {
    value: number;
    currency: string;
    contents?: { id: any; quantity: any }[];
  }): Promise<void>;
  trackCompleteRegistration(): Promise<void>;
}

const FacebookSdkAnalytics = registerPlugin<FacebookSdkAnalyticsPlugin>(
  "FacebookSdkAnalytics"
);

@Injectable({
  providedIn: "root",
})
export class AnalyticsFacebookSdkService {
  public trackPurchase(grand_total, cart, groupApp) {
    const facebookSdkEnabled = this.isFacebookSdkEnabled(groupApp);
    const nativePlatform = Capacitor.isNativePlatform();
    const pluginAvailable = Capacitor.isPluginAvailable(
      "FacebookSdkAnalytics"
    );

    console.log("facebook sdk trackPurchase check", {
      facebookSdkEnabled: facebookSdkEnabled,
      nativePlatform: nativePlatform,
      pluginAvailable: pluginAvailable,
      grand_total: grand_total,
    });

    if (!facebookSdkEnabled || !nativePlatform) {
      console.log("facebook sdk trackPurchase skipped");
      return;
    }

    if (!pluginAvailable) {
      console.log("facebook sdk trackPurchase pluginAvailable false, trying native call anyway");
    }

    const value = parseFloat(grand_total);

    if (_.isNaN(value)) {
      console.log("facebook sdk trackPurchase skipped invalid value", {
        grand_total: grand_total,
      });
      return;
    }

    const contents = _.map(cart || [], (item) => {
      return {
        id: item.product_id,
        quantity: item.quantity,
      };
    });

    try {
      FacebookSdkAnalytics.trackPurchase({
        value: value,
        currency: "EUR",
        contents: contents,
      })
        .then(() => {
          console.log("facebook sdk trackPurchase sent");
        })
        .catch((err) => {
          console.log("facebook sdk trackPurchase error", err);
        });
    } catch (err) {
      console.log("facebook sdk trackPurchase sync error", err);
    }
  }

  public trackCompleteRegistration(groupApp) {
    const facebookSdkEnabled = this.isFacebookSdkEnabled(groupApp);
    const nativePlatform = Capacitor.isNativePlatform();
    const pluginAvailable = Capacitor.isPluginAvailable(
      "FacebookSdkAnalytics"
    );

    console.log("facebook sdk CompleteRegistration check", {
      facebookSdkEnabled: facebookSdkEnabled,
      nativePlatform: nativePlatform,
      pluginAvailable: pluginAvailable,
    });

    if (!facebookSdkEnabled || !nativePlatform) {
      console.log("facebook sdk CompleteRegistration skipped");
      return;
    }

    if (!pluginAvailable) {
      console.log("facebook sdk CompleteRegistration pluginAvailable false, trying native call anyway");
    }

    try {
      FacebookSdkAnalytics.trackCompleteRegistration()
        .then(() => {
          console.log("facebook sdk CompleteRegistration sent");
        })
        .catch((err) => {
          console.log("facebook sdk CompleteRegistration error", err);
        });
    } catch (err) {
      console.log("facebook sdk CompleteRegistration sync error", err);
    }
  }

  private isFacebookSdkEnabled(groupApp) {
    return !!(
      groupApp &&
      groupApp.facebookSdkEnabled &&
      groupApp.facebookCode &&
      groupApp.facebookClientToken
    );
  }
}
